/**
 * 活动指标
 **/

import React from 'react';
import styled from "styled-components";
import Draggable from 'react-draggable';
import {componentWillAppendToBody} from "react-append-to-body";
import {Icon, Select, Spin} from "antd";
import {mobile_url_domin} from "../../utils/config";


const BodyDraggable = componentWillAppendToBody(Draggable);

const MobileWrapper = styled.div`
    box-shadow: rgb(235, 235, 235) 0px 2px 4px;
    pointer-events: auto;
    position: relative;
    width: 375Px;
    padding: 0;
    box-shadow: 0 10px 51px rgba(0, 0, 0, 0.8);
    .no-cursor{
      cursor: auto !important;
    }
    .aside-demo{
     
    }
    
    #eventPreviewFrame{
        width: 375px; 
        height: 568px; border-top: none;
        border: none;
    }
    .url-box{
        width: 350Px;
        height: 28Px;
        line-height: 28Px;
        color: #fff;
        background-color: #a2a2a2;
        margin: 0 auto;
        border-radius: 4Px;
        white-space: nowrap;
        overflow-x: hidden;
    }
   
    .demo-preview-wrapper {
      margin: 0 auto;
    }
    
    .demo-preview-wrapper{
        .code-box-demo-preview{
          height: 568px;
          background-color: #ffffff;
        }
        .demo-preview-header {
            border-radius: 4Px 4Px 0 0;
            /*background: -webkit-gradient(linear, left top, left bottom, from(#373737fa), to(#545456));
            background: -webkit-linear-gradient(#373737fa, #545456);
            background: linear-gradient(#373737fa, #545456);*/
            background: url("https://os.alipayobjects.com/rmsportal/VfVHYcSUxreetec.png") no-repeat #545456;
            background-size: 93%;
            background-position: 15px 7px;
            text-align: center;
            cursor: move;
            
        }
        .demo-preview-footer{
          height: 40px;
          background-color: #545456;
          display: flex;
          >a{
            display: inline-block;
            text-align: center;
            line-height: 40px;
            height: 40px;
            width: 50%;
            color: #b9b9b9b9;
            font-size: 22px;
            &:hover{
              color: #ffffff;
            }
          }
        }
    }
    
   
   
   .demo-preview-statbar{
      height: 20Px;
      margin-bottom: 4Px;
      &>img{
        margin: 0px 2px;
        width: 350px;
      }
   }
   
   .mobile-address-select-dropdown .ant-select-dropdown-menu-item{
      text-align: center;
   }
`


const MobileAddressSelect = styled(Select)`
  width: 100%;
  .ant-select-selection{
    color: #fff;
    background-color: #a2a2a2;
    border:none;
  }
  .ant-select-selection__rendered{
        display: flex;
        justify-content: center;
  }
`


class EvtPreview extends React.Component {
    constructor(props) {
        super();
        this.state = {
            visible: false,
            activeDrags: 0,
            mobileAddressSelectedVal: "1",
        };
    }

    show = () => {
        this.setState({
            visible: true
        })

    }
    hide = () => {
        this.setState({
            visible: false
        })
    }

    onStart = () => {
        this.setState({activeDrags: ++this.state.activeDrags});
    }

    onStop = () => {
        this.setState({activeDrags: --this.state.activeDrags});
    }

    mobileAddressSelectChange = (value) => {
        this.setState({
            mobileAddressSelectedVal: value
        })
    }

    render() {

        var iframeSrc = null;
        if (this.props.eventId) {
            if (this.state.mobileAddressSelectedVal == "1") {
                this.props.templateName && this.props.templateName !='event' ? iframeSrc = `/mobile/invitation-template/${this.props.eventId}?name=${this.props.templateName}`
                    :
                    iframeSrc = `/mobile/event/${this.props.eventId}`;
            } else if (this.state.mobileAddressSelectedVal == "2") {
                iframeSrc = `/mobile/signup/${this.props.eventId}`;
            }
        }

        if (!this.state.visible)
            return null;

        return (
            <BodyDraggable bounds="body" onStart={this.onStart} onStop={this.onStop} cancel=".no-cursor">
                <MobileWrapper id="mobile-wrapper" class="mobile-wrapper" style={{display: this.state.visible ? "block" : "none", position: 'absolute', bottom: '100px', right: '30px', zIndex: 15000}}>
                    <div className="aside-demo">
                        <div style={{width: "375px", height: " 672px"}}>
                            <div className="demo-preview-wrapper">
                                <div className="demo-preview-header">
                                    <div className="demo-preview-statbar">

                                    </div>
                                    <div style={{height: "40px"}} className="no-cursor">
                                        <div className="url-box">
                                            <MobileAddressSelect value={this.state.mobileAddressSelectedVal} size="small"
                                                                 onChange={this.mobileAddressSelectChange}
                                                                 dropdownClassName={"mobile-address-select-dropdown"}
                                                                 getPopupContainer={() => document.getElementById('mobile-wrapper')}>
                                                <Select.Option value="1">活动页面</Select.Option>
                                                <Select.Option value="2">报名页面</Select.Option>
                                            </MobileAddressSelect>
                                        </div>
                                    </div>
                                </div>
                                <section className="code-box-demo code-box-demo-preview">
                                    <Spin spinning={this.props.eventId ? false : true}>
                                        <iframe id="eventPreviewFrame" src={`${mobile_url_domin}${iframeSrc}`} name="eventPreviewFrame">

                                        </iframe>
                                    </Spin>
                                </section>
                                <div className="demo-preview-footer">
                                    <a onClick={(e) => {
                                        e.preventDefault();
                                        document.getElementById('eventPreviewFrame').contentWindow.history.back();
                                    }}><Icon type="caret-left"/></a>
                                    <a onClick={this.hide}><Icon type="close"/></a>


                                </div>
                            </div>
                        </div>
                    </div>
                </MobileWrapper>
            </BodyDraggable>
        );
    }
}
EvtPreview.defaultProps = {
    eventId:null,
    templateName:null,//邀请函模板名称

};
export default EvtPreview;


// WEBPACK FOOTER //
// ./src/containers/evt/EvtPreview.jsx